"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATASET_EXPORT_MANIFEST_VERSION = exports.datasetExportTypes = exports.datasetImportTypeMap = exports.datasetImportTypes = void 0;
// Dataset import types
exports.datasetImportTypes = [
    'CUSTOM_IMPORT_TYPE',
    'CSV_IMPORT_TYPE',
    'IMAGE_IMPORT_TYPE',
    'AUDIO_IMPORT_TYPE',
    'STRING_XML_IMPORT_TYPE',
];
// Dataset import types mapped to objects
exports.datasetImportTypeMap = {
    CUSTOM_IMPORT_TYPE: {
        key: 'custom',
        name: 'Custom',
        files_required: ['json'],
        files_optional: ['tgz'],
    },
    CSV_IMPORT_TYPE: {
        key: 'csv',
        name: 'CSV',
        files_required: ['csv'],
        files_optional: ['tgz'],
    },
    IMAGE_IMPORT_TYPE: {
        key: 'image',
        name: 'Image',
        files_required: ['tgz'],
    },
    AUDIO_IMPORT_TYPE: {
        key: 'audio',
        name: 'Audio',
        files_required: ['tgz'],
    },
    STRING_XML_IMPORT_TYPE: {
        key: 'android_strings',
        name: 'Android Strings',
        files_required: ['xml'],
    },
};
// Dataset export types
exports.datasetExportTypes = ['DEFAULT_EXPORT_TYPE', 'GROUP_BY_DATASET', 'GROUP_BY_AVATAR'];
// Manifest export (JSON Lines): header line, one datapoint JSON object per line, then {"complete":true}.
exports.DATASET_EXPORT_MANIFEST_VERSION = 2;
//# sourceMappingURL=Index.js.map